const ArrowNarrowLeft = ({ width, height, color, rotate, strokeWidth }) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={rotate ? { transform: `rotate(${rotate}deg)` } : {}}
    >
      <path
        d="M13.3337 8H2.66699M2.66699 8L6.66699 12M2.66699 8L6.66699 4"
        stroke={color || "#0E1B1B"}
        strokeWidth={strokeWidth || "1.6"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowNarrowLeft;
